import { create } from "axios";

const apiDev = create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  timeout: 10000,
});

const apiProd = create({
  baseURL: process.env.REACT_APP_PROD_API_URL,
  timeout: 10000,
});

export { apiDev, apiProd };
